import styled, { keyframes, css } from "styled-components";

const fontTitle = "Raleway";
const fontPrices = "Open Sans";

type ModalProps = {
  show: boolean;
  color: string;
  loading: boolean;
};

const slideUp = keyframes`
    from {
        transform: translate(0, 100%);
        visibility: hidden;
        opacity: 0;
    }
    to {
        transform: translate(0, 0);
        visibility: visible;
        opacity: 1;
    }
`;

const slideDown = keyframes`
    from {
        transform: translate(0, 0); 
    }
    to {
        transform: translate(0, 100vh);
        visibility: hidden;
        overflow: hidden;
    }
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45vh;
`;

const ResponsiveModal = styled.div<ModalProps>`
  display: none;
  svg:hover {
    fill: ${(props) => props.color};
    cursor: pointer;
  }

  .modal-image-container {
    position: relative;
  }
  .modal-image {
    position: relative;
    width: 16rem;
    height: 16rem;
    border-radius: 10px;
    position: relative !important;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      width: 22rem;
      height: 21.3rem;
      min-width: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
      display: inline-block;
    }
  }
  .ml-1 {
    margin-left: 0.5rem;
  }
  .p-sides {
    padding: 0.75rem 2.1rem;
  }
  

  .product-discountPrice {
    font-family: ${fontPrices};
    // margin-left: 1rem;
    font-size: 0.8rem;
    font-weight: 400;
    color: #999999;
    text-decoration: line-through;
    margin-top: 0.2rem;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      font-size: 0.9rem;
    }
  }

  .product-mainPrice {
    font-family: ${fontPrices};
    color: #999999;
    font-size: 0.8rem;
    font-weight: 700;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      font-size: 1.2rem;
    }
  }
  .product-data-totalPrice {
    font-family: ${fontPrices};
    margin-top: 0.5rem;
    font-weight: bold;
    .product-data-totalText {
      font-size: 0.8rem;
    }
    .product-data-totalAmount {
      margin-top: 0.3rem;
      font-family: ${fontPrices};
      font-size: 1.5rem;
      margin-bottom: 1.1rem;
      font-weight: 700;
      color: #222222;
      @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        font-size: 2rem;
      }
    }
  }

  .product-data-sales {
    margin: 0.7rem auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #e2e2e2;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      border-bottom: 0;
      margin: 0;
      display: none;
    }
    /* &:after{
                content: "";
                width: 100%;
                height: 2px;
                background: #E2E2E2;
            } */
  }

  .modal-main {
    padding: 1vh;
    position: fixed;
    background: white;
    height: auto;
    min-height: 350px;
  
    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
      max-height: 100vh;
      min-width: 60vw;
      max-width: 60vw;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      justify-content: space-between
    }
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      bottom:0;
      width: 100%;
      padding: 0;
      height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 3.75rem;
      box-sizing: border-box;
      border-top-left-radius: 1.5rem;
      border-top-right-radius: 1.5rem;
      ${(props) => props.loading ? `align-items: center;` : ``}
    
    }
  }
  .container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.5rem 0.5rem 0rem 0.5rem; 
    width: 100%;
    height: 85%;
    box-sizing: border-box;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      display: block;
      flex: 0 0 auto;
      width: auto;
      height: auto;
      margin: 2.8rem 0.5rem 0 0.5rem;
      padding: 0.5rem;
      overflow: visible;
    }
  }
  .container__product-info {
    flex-direction: row;
    margin-left: 1rem;
    flex-grow: 1;
    flex: 1;
    height: 16rem;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      margin: 0;
      width: 100%;
      height: auto;
      margin-bottom: 1rem;
    }
  }
  .product-data-title {
    font-family: ${fontTitle};
    margin-top: -0.4rem;
    font-size: 1.2rem;
    font-weight: 400;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      font-weight: 500;
      font-size: 1.4rem;
      display: none;
      margin-top: 0;
      margin-bottom: 1rem;
    }
  }
  .product-data-subtitle {
    font-family: ${fontTitle};
    font-size: 1rem;
    font-weight: 400;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      font-size: 1.3rem;
    }
  }
  .product-data-reference{
    font-size: 0.9rem;
    font-weight: 600;
    font-family: ${fontPrices};
    color: #999999;
    margin-bottom: 0.4rem;

  }
  .cart-data-buttons {
    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
      display: flex;
      box-sizing: border-box;
      * { 
        padding: 0.8em 2em;
        margin: 1vh 1vh 0 0;
        font-size: 0.75em;
      }
    }
    
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      margin: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      z-index: 3;
      * {
        margin: 0;
        padding: 0;
        border-radius: 0;
        flex: 1;
        height: 3.75rem;
      }
    }
  }
  .show-mobile {
    display: none;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      display: flex;
    }
  }

  ${(props) =>
    props.show &&
    ` display: block;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10005;
      background: rgba(0, 0, 0, 0.4);
    `}

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    bottom: 50px;
    animation: ${(props) =>
      props.show
        ? css`
            ${slideUp} .75s forwards 1
          `
        : css`
            ${slideDown} .75s forwards 1
          `};
  } ;
`;

export { ResponsiveModal };
